export default __webpack_public_path__ + "media/color/bze-6b663423.svg";